var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6273 15.2761H11.3363V10.9402H12.7544C13.114 10.9402 13.3265 10.5316 13.114 10.2373L10.3555 6.4204C10.1798 6.17521 9.8161 6.17521 9.64038 6.4204L6.8819 10.2373C6.66939 10.5316 6.87781 10.9402 7.24152 10.9402H8.65958V15.2761H3.8537C1.70821 15.1576 0 13.1511 0 10.977C0 9.47721 0.813241 8.16948 2.0188 7.4625C1.90846 7.16417 1.85125 6.84542 1.85125 6.51031C1.85125 4.97782 3.0895 3.73957 4.62199 3.73957C4.953 3.73957 5.27176 3.79678 5.57009 3.90712C6.45689 2.02727 8.36943 0.723633 10.5926 0.723633C13.4696 0.727719 15.8398 2.93042 16.1095 5.73794C18.3204 6.11799 20 8.1654 20 10.4825C20 12.959 18.0711 15.1045 15.6273 15.2761Z",
    fill: "#D4D5D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloud-upload.c3b77ec856128b5fe549829c974aca20.svg";
export { ForwardRef as ReactComponent };